import Vue from 'vue'

export default {
    UPDATE_PARENTCORP (state, value) {
        Vue.set(state, 'parentCorp', value);
    },
    SET_PARENTCORP (state, value) {
        this.commit('UPDATE_PARENTCORP', value);
    },
    SET_SELECTED_PARENTCORP (state,  value ) {
      Vue.set(state, 'selectedParentCorp', value);
    },
    SET_PARENT_CORP_USER_LIST (state,  value ) {
      Vue.set(state, 'parentCorpUserList', value);
    },
    SET_FILTER_RESULTS (state,  value ) {
      Vue.set(state, 'filterResults', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/parentCorporations/mutations.js